var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{class:_vm.$style.title},[_vm._v(_vm._s(_vm.$t('projects.all_projects')))]),_c('ProjectList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }